import React, { useState,useEffect } from 'react';
import { Button } from 'react-bootstrap';
import UseApiService from "./../../../services/Api.service";
import * as constantes from './../../../constants/Constants' 

export default function Principal({handleChange}) {
  const [loginUrl, setLoginUrl] = useState('');
  
    // URLs de autenticación proporcionadas por tu API
    const urls = {
      google: 'https://accounts.google.com/o/oauth2/auth', // URL de Google
      facebook: 'https://www.facebook.com/v12.0/dialog/oauth', // URL de Facebook
      apple: 'https://appleid.apple.com/auth/authorize', // URL de Apple
    };

    useEffect(()=>{
      if(loginUrl){        
        openLoginWindow(loginUrl);        
      }
    },[loginUrl])
  
    // Función para abrir una ventana emergente sin que se muestre en la barra de tareas
    const openLoginWindow = (url) => {
      const width = 500;
      const height = 600;
      const left = (window.innerWidth - width) / 2;  // Centrar la ventana horizontalmente
      const top = (window.innerHeight - height) / 2; // Centrar la ventana verticalmente
  
      // Configuración de la ventana emergente
      const features = `
        width=${width},
        height=${height},
        top=${top},
        left=${left},
        toolbar=no,
        menubar=no,
        resizable=no,
        scrollbars=no,
        location=no,
        status=no
      `;
  
      // Abre la ventana emergente
      window.open(url, 'SocialLoginWindow', features);
    };

    const getSocialUri = (tipoSocial) => {
      
      UseApiService(constantes.C_API_SOCIAL_URL, {
        method: 'POST',
        body:{ socialtype: tipoSocial}
      })
      .then(({ data, error }) => {
        if (error) {

        } else {
          if (data.uri) {
            setLoginUrl(data.uri);
          }
          else{
            setLoginUrl('');
          }
        }
      })
      .catch((e)=>{
        setLoginUrl('');
      })
      .finally((e)=>{
      });
    }

  return (      
      <>
        <div className="d-flex flex-column flex-md-row justify-content-center gap-2">
          <Button 
            className="btn btn-light bg-white d-flex flex-sm-column flex-row align-items-center p-3 rounded"
            onClick={()=>getSocialUri('FACEBOOK')}
          >
            <svg className='me-2' width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.666 10.5C20.666 4.98 16.186 0.5 10.666 0.5C5.14602 0.5 0.666016 4.98 0.666016 10.5C0.666016 15.34 4.10602 19.37 8.66602 20.3V13.5H6.66602V10.5H8.66602V8C8.66602 6.07 10.236 4.5 12.166 4.5H14.666V7.5H12.666C12.116 7.5 11.666 7.95 11.666 8.5V10.5H14.666V13.5H11.666V20.45C16.716 19.95 20.666 15.69 20.666 10.5Z" fill="#0068FF"/>
            </svg>
            <span className='fw-bold'>Continúa con Facebook</span>
          </Button>              
          <Button 
            className="btn btn-light bg-white d-flex flex-sm-column flex-row align-items-center p-3 rounded"
            onClick={()=>getSocialUri('APPLE')}
          >
            <svg className='me-2' width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.0394 19.1976C12.9507 20.253 11.7619 20.0864 10.6176 19.5864C9.40668 19.0754 8.29571 19.0532 7.01809 19.5864C5.41829 20.2752 4.57395 20.0752 3.61852 19.1976C-1.80302 13.6094 -1.00312 5.09936 5.15166 4.78828C6.65147 4.86605 7.69578 5.6104 8.57345 5.67706C9.88439 5.41043 11.1398 4.64386 12.5396 4.74385C14.2172 4.87716 15.4837 5.54374 16.3169 6.74359C12.8507 8.82111 13.6728 13.3872 16.8502 14.6648C16.2169 16.3313 15.3948 17.9866 14.0283 19.2087L14.0394 19.1976ZM8.46235 4.72163C8.29571 2.24416 10.3066 0.199975 12.6174 0C12.9396 2.8663 10.0177 4.99937 8.46235 4.72163Z" fill="black"/>
            </svg>
            <span className='fw-bold'>Continúa con Apple ID</span>
          </Button>
          <Button 
            className="btn btn-light bg-white d-flex flex-sm-column flex-row align-items-center p-3 rounded"
            onClick={()=>getSocialUri('GOOGLE')}
          >
            <svg className='me-1' width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.1375 10.5415H21.332V10.5H12.332V14.5H17.9835C17.159 16.8285 14.9435 18.5 12.332 18.5C9.01853 18.5 6.33203 15.8135 6.33203 12.5C6.33203 9.1865 9.01853 6.5 12.332 6.5C13.8615 6.5 15.253 7.077 16.3125 8.0195L19.141 5.191C17.355 3.5265 14.966 2.5 12.332 2.5C6.80953 2.5 2.33203 6.9775 2.33203 12.5C2.33203 18.0225 6.80953 22.5 12.332 22.5C17.8545 22.5 22.332 18.0225 22.332 12.5C22.332 11.8295 22.263 11.175 22.1375 10.5415Z" fill="#FFC107"/>
              <path d="M3.48438 7.8455L6.76987 10.255C7.65887 8.054 9.81188 6.5 12.3314 6.5C13.8609 6.5 15.2524 7.077 16.3119 8.0195L19.1404 5.191C17.3544 3.5265 14.9654 2.5 12.3314 2.5C8.49038 2.5 5.15937 4.6685 3.48438 7.8455Z" fill="#FF3D00"/>
              <path d="M12.3322 22.5003C14.9152 22.5003 17.2622 21.5118 19.0367 19.9043L15.9417 17.2853C14.9041 18.0749 13.636 18.5017 12.3322 18.5003C9.73119 18.5003 7.52269 16.8418 6.69069 14.5273L3.42969 17.0398C5.08469 20.2783 8.44569 22.5003 12.3322 22.5003Z" fill="#4CAF50"/>
              <path d="M22.1375 10.5415H21.332V10.5H12.332V14.5H17.9835C17.5891 15.6082 16.8787 16.5766 15.94 17.2855L15.9415 17.2845L19.0365 19.9035C18.8175 20.1025 22.332 17.5 22.332 12.5C22.332 11.8295 22.263 11.175 22.1375 10.5415Z" fill="#1976D2"/>
            </svg>
            <span className='fw-bold'>Continúa con Google</span>
          </Button>
        </div>
        <div className='text-center py-3'>
          O
        </div>
        <div className="btns">
          <Button className='btns-primary' onClick={()=>handleChange('login')}>Inicial sesión</Button>
          <Button className='btns-secondary' onClick={()=>handleChange('registrar')}>Regístrarse</Button>
        </div>
      </>
  );
}